import GeneralService from "./GeneralService";
import { Component } from "react";

export class ModelService extends Component {
  public static getModels(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/model",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static disableModel(
    modelId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/model/${modelId}/disable`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static enableModel(
    modelId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/model/${modelId}/enable`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
